import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { customerMe } from "../lib/api";

const CustomerAuthContext = createContext(null);
const TOKEN_KEY = "zrh_customer_token";

export function CustomerAuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || "");
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async (tk) => {
    const t = tk || token;
    if (!t) { setCustomer(null); setLoading(false); return; }
    try {
      const me = await customerMe(t);
      setCustomer(me);
    } catch {
      localStorage.removeItem(TOKEN_KEY);
      setToken("");
      setCustomer(null);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { refresh(); /* eslint-disable-next-line */ }, []);

  const login = (tk, cust) => {
    localStorage.setItem(TOKEN_KEY, tk);
    setToken(tk);
    setCustomer(cust);
  };
  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setToken("");
    setCustomer(null);
  };

  return (
    <CustomerAuthContext.Provider value={{ token, customer, loading, login, logout, setCustomer, refresh }}>
      {children}
    </CustomerAuthContext.Provider>
  );
}

export const useCustomerAuth = () => useContext(CustomerAuthContext);
